const Link = {
  baseStyle: {
    textDecoration: {
      base: "underline",
      xl: "none",
    },
    _hover: {
      color: "inherit",
      base: "underline",
    },
  },
};

export default Link;
